import { render, staticRenderFns } from "./DisapprovedReasonEdit.vue?vue&type=template&id=2b6d7306"
import script from "./DisapprovedReasonEdit.vue?vue&type=script&lang=js"
export * from "./DisapprovedReasonEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports